import _ from 'lodash';
import { useIntl } from 'react-intl';

import { useOptionalMessage } from 'Hooks/useOptionalMessage';
import { SelectInput } from 'Views/Components/New/SelectInput';
import { BookingWizardData } from '../../BookingWizardData/BaseBookingWizardData';
import { isVehicleBookingWizardData, VehicleBookingWizardData } from '../../BookingWizardData/VehicleBookingWizardData';
import { useBookingWizardDataStore } from '../../BookingWizardDataStore';
import { WizardErrors } from '../../BookingWizardTypes';
import { VehicleTabActionCreators, wizardDataVehicleTabReducer } from './Reducers/vehicleTabReducer';
import { useVehicleTabContext } from './VehicleTabContext';

export function VehicleMakeInput() {
	const { cargoTypes } = useVehicleTabContext();
	const intl = useIntl();
	const fmtOptional = useOptionalMessage();
	const { wizardData, setWizardData, innerWizardErrors, setInnerWizardErrors } = useBookingWizardDataStore();

	if (!isVehicleBookingWizardData(wizardData.innerWizardData)) {
		return <></>;
	}

	const typedErrors = innerWizardErrors as WizardErrors<VehicleBookingWizardData>;
	const { cargoMake } = wizardData.innerWizardData;

	// Configurable help text shown beside the "Make" label. Operators can override this per-tenant
	// translation, or blank it out entirely to hide the tooltip.
	const makeTooltip = fmtOptional({
		id: 'vehicle-tab__vehicle-make__tooltip',
		defaultMessage: "Can't find your vehicle in the list? Get in touch and we'll help you get booked in.",
	});

	const options = _.uniq(
		cargoTypes.sort((a, b) => a.cargoMake.trim().localeCompare(b.cargoMake.trim())).map(x => x.cargoMake.trim()),
	)
		// Generic vehicle types are migration-only and shouldn't be exposed in the UI.
		.filter(x => !x.startsWith('Generic'))
		.map(x => ({ value: x, label: x }));

	return (
		<SelectInput
			className="vehicle-make"
			label={intl.formatMessage({
				id: 'vehicle-tab__vehicle-make__label',
				defaultMessage: 'Make',
			})}
			tooltip={makeTooltip || undefined}
			placeholder={intl.formatMessage({
				id: 'vehicle-tab__vehicle-make__placeholder',
				defaultMessage: 'Select make',
			})}
			options={options}
			value={cargoMake ? { value: cargoMake, label: cargoMake } : null}
			required
			isSearchable
			error={typedErrors?.cargoMake}
			onChange={(option: any) => {
				const selectedMake = option?.value ?? '';
				const staged = new BookingWizardData({ ...wizardData });
				if (isVehicleBookingWizardData(staged.innerWizardData)) {
					staged.innerWizardData.cargoMake = selectedMake;
				}
				const newData = wizardDataVehicleTabReducer(staged, VehicleTabActionCreators.changeMake());
				if (newData) {
					setWizardData(newData);
				}

				const newErrors = { ...typedErrors };
				delete newErrors.cargoMake;
				setInnerWizardErrors(newErrors);
			}}
		/>
	);
}
